(function () {
  var CONFIG = window.CART_SUBSCRIPTION_CONFIG;
  if (!CONFIG) return;

  var MAX_QTY = CONFIG.maxQty || 3;
  var SELLING_PLANS = CONFIG.sellingPlans || {};
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var isUpdating = false;

  // window.routes.* point at the HTML cart endpoints (e.g. /cart/change),
  // which return a full HTML page. The AJAX API needs the `.js` variant.
  function cartUrl(name, fallback) {
    var base = (window.routes && window.routes[name]) || fallback;
    return /\.js$/.test(base) ? base : base + '.js';
  }

  function getSellingPlan(weight, qty) {
    var plans = SELLING_PLANS[weight];
    return plans ? plans[String(qty)] || null : null;
  }

  function updateCartIcon(itemCount) {
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.classList.toggle('cart-empty', itemCount <= 0);
  }

  // Render the cart-drawer + cart-icon sections from a cart state that
  // includes a `sections` object (as returned by change.js / cart.js?sections).
  function renderSections(cartState) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var itemCount = typeof cartState.item_count === 'number' ? cartState.item_count : 0;
    cartDrawer.classList.toggle('is-empty', itemCount === 0);

    if (
      cartState.sections &&
      typeof cartDrawer.getSectionsToRender === 'function' &&
      typeof cartDrawer.getSectionInnerHTML === 'function'
    ) {
      cartDrawer.getSectionsToRender().forEach(function (section) {
        var el = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!el || !cartState.sections[section.id]) return;
        el.innerHTML = cartDrawer.getSectionInnerHTML(cartState.sections[section.id], section.selector);
      });

      // Replacing #CartDrawer innerHTML recreates the overlay, which loses
      // its click-to-close listener. Re-bind it (mirrors Dawn behaviour).
      var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', function () {
          cartDrawer.close();
        });
      }
    }

    updateCartIcon(itemCount);
  }

  // Pull the authoritative cart state (with sections) and re-render.
  // Used as a recovery path so the UI never shows a stale quantity.
  // /cart/update.js with no changes returns the full cart + sections.
  function resyncCart() {
    return postJSON(cartUrl('cart_update_url', '/cart/update'), {
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(renderSections)
      .catch(function (e) {
        console.error('[cart-subscription] resync failed:', e);
      });
  }

  function setLoading(control, loading) {
    if (!control) return;
    control.classList.toggle('is-loading', loading);
    control.querySelectorAll('.cart-qty-btn').forEach(function (b) {
      b.disabled = loading;
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function changeLine(lineKey, quantity) {
    return postJSON(cartUrl('cart_change_url', '/cart/change'), {
      id: lineKey,
      quantity: quantity,
      sections: SECTIONS,
      sections_url: window.location.pathname
    });
  }

  function addItem(variantId, quantity, sellingPlanId, weight) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', quantity);
    if (sellingPlanId) fd.append('selling_plan', sellingPlanId);
    if (weight) fd.append('properties[Hundegewicht]', weight);
    fd.append('properties[_kauftyp]', sellingPlanId ? 'abo' : 'single');

    return fetch(cartUrl('cart_add_url', '/cart/add'), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json(); });
  }

  function handleError(error) {
    console.error('[cart-subscription]', error);
    var msg = error && error.message ? error.message : 'Unbekannter Fehler';
    alert('Menge konnte nicht aktualisiert werden: ' + msg);
    // Always re-sync so the drawer reflects the true cart state.
    return resyncCart();
  }

  // Subscriptions: each quantity maps to a different selling plan, and
  // change.js cannot swap selling plans. So we ADD the new (subscription)
  // line first, then remove the old one. Adding first means a failure never
  // loses the item from the cart. Works for qty swaps AND single -> abo.
  function swapLine(oldKey, variantId, weight, newQty) {
    var plan = getSellingPlan(weight, newQty);
    if (!plan) {
      alert('Lieferfrequenz für dieses Gewicht ist nicht verfügbar.');
      return Promise.resolve();
    }

    return addItem(variantId, newQty, plan.id, weight)
      .then(function (addResp) {
        if (addResp.status) {
          throw new Error(addResp.description || addResp.message || 'Hinzufügen fehlgeschlagen');
        }
        return changeLine(oldKey, 0);
      })
      .then(function (changeResp) {
        if (changeResp.status) {
          throw new Error(changeResp.description || changeResp.message || 'Entfernen fehlgeschlagen');
        }
        renderSections(changeResp);
      })
      .catch(handleError);
  }

  function updateSubscriptionQuantity(control, newQty) {
    setLoading(control, true);
    return swapLine(control.dataset.key, control.dataset.variantId, control.dataset.weight, newQty);
  }

  // Single purchase: plain quantity change, capped by MAX_QTY in the handler.
  function updateSingleQuantity(control, newQty) {
    var key = control.dataset.key;

    setLoading(control, true);

    return changeLine(key, newQty)
      .then(function (resp) {
        if (resp.status) {
          throw new Error(resp.description || resp.message || 'Aktualisieren fehlgeschlagen');
        }
        renderSections(resp);
      })
      .catch(handleError);
  }

  function release() {
    isUpdating = false;
  }

  function handleQtyClick(btn) {
    var control = btn.closest('.cart-item__qty-control');
    if (!control) return;

    var currentQty = parseInt(control.dataset.quantity, 10);
    if (isNaN(currentQty)) return;

    var delta = btn.classList.contains('cart-qty-btn--plus') ? 1 : -1;
    var newQty = currentQty + delta;
    if (newQty < 1 || newQty > MAX_QTY || newQty === currentQty) return;

    isUpdating = true;
    var op =
      control.dataset.kauftyp === 'abo'
        ? updateSubscriptionQuantity(control, newQty)
        : updateSingleQuantity(control, newQty);
    Promise.resolve(op).then(release, release);
  }

  // Upsell "Jetzt sparen":
  //  - add-dose on a single-purchase line: bump quantity by one (plain change.js).
  //  - add-dose on a subscription line: swap to the higher-qty selling plan.
  //  - activate-abo: convert a single line to a subscription at the current qty.
  function handleUpsellClick(btn) {
    var box = btn.closest('.cart-upsell');
    if (!box) return;

    var currentQty = parseInt(box.dataset.quantity, 10) || 1;
    var isSingle = box.dataset.kauftyp !== 'abo';

    isUpdating = true;
    btn.disabled = true;
    box.classList.add('is-loading');

    var op;
    if (box.dataset.action === 'add-dose') {
      var newQty = Math.min(currentQty + 1, MAX_QTY);
      if (isSingle) {
        op = changeLine(box.dataset.key, newQty)
          .then(function (resp) {
            if (resp.status) {
              throw new Error(resp.description || resp.message || 'Aktualisieren fehlgeschlagen');
            }
            renderSections(resp);
          })
          .catch(handleError);
      } else {
        op = swapLine(box.dataset.key, box.dataset.variantId, box.dataset.weight, newQty);
      }
    } else {
      op = swapLine(box.dataset.key, box.dataset.variantId, box.dataset.weight, Math.min(currentQty, MAX_QTY));
    }

    Promise.resolve(op).then(release, release);
  }

  document.addEventListener('click', function (event) {
    var qtyBtn = event.target.closest('.cart-qty-btn');
    if (qtyBtn) {
      if (qtyBtn.disabled || isUpdating) return;
      event.preventDefault();
      handleQtyClick(qtyBtn);
      return;
    }

    var upsellBtn = event.target.closest('.cart-upsell__btn');
    if (upsellBtn) {
      if (upsellBtn.disabled || isUpdating) return;
      event.preventDefault();
      handleUpsellClick(upsellBtn);
    }
  });
})();
